import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 24h25c6.63 0 12-5.37 12-12S43.63 0 37 0H12C5.37 0 0 5.37 0 12s5.37 12 12 12",
      style: {"fill":"#e0ad5a"}
    }, null, -1)
  ])))
}
export default { render: render }